// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__28Wrr","footer":"ChangeClinic_footer__1CXwv"};